import { Component, OnInit, Input } from '@angular/core';
import { QuestionProcessingService } from '../../services/question-processing.service';

@Component({
  selector: 'app-check-box',
  templateUrl: './check-box.component.html',
  styleUrls: ['./check-box.component.css']
})
export class CheckBoxComponent implements OnInit {
  @Input() model : boolean;
  @Input() for : string;
  @Input() text : string;
  constructor() { }

  modelFlip(){
    this.model[this.for] = !this.model[this.for];
  }
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/utility-components/check-box/check-box.component.ts